import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPapuaNewGuinea = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1997)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M20.4853 20.4853C15.799 25.1716 8.20108 25.1716 3.5147 20.4853C-1.17158 15.799 -1.17158 8.20097 3.51475 3.51464C8.20103 -1.17164 15.0611 -0.433784 19.7474 4.25255C24.4337 8.93883 25.1716 15.799 20.4853 20.4853Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51477 3.5147C8.20105 -1.17158 15.799 -1.17149 20.4853 3.51475C25.1716 8.20103 25.1716 15.799 20.4853 20.4853",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.17067 16.1739L9.36492 16.7718H9.99356L9.48497 17.1413L9.67926 17.7392L9.17067 17.3697L8.66208 17.7392L8.85633 17.1413L8.34778 16.7718H8.97637L9.17067 16.1739Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.56519 10.4348L7.88905 11.4313H8.93671L8.08907 12.047L8.41284 13.0435L7.56519 12.4276L6.7176 13.0435L7.04141 12.047L6.19373 11.4313H7.24148L7.56519 10.4348Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.56519 17.7392L7.88896 18.7356H8.93671L8.08898 19.3514L8.41284 20.3479L7.56519 19.732L6.7176 20.3479L7.04132 19.3514L6.19373 18.7356H7.24133L7.56519 17.7392Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.6285 13.0435L10.9524 14.04H12L11.1524 14.6557L11.4761 15.6522L10.6285 15.0363L9.78091 15.6522L10.1047 14.6557L9.25708 14.04H10.3048L10.6285 13.0435Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.50184 13.0435L4.8257 14.04H5.87331L5.02572 14.6557L5.34943 15.6522L4.50184 15.0363L3.6542 15.6522L3.97806 14.6557L3.13037 14.04H4.17807L4.50184 13.0435Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.0883 8.88566C19.552 8.34936 18.8551 8.03253 18.1063 7.97811L20.3478 6.23469C19.4551 5.34195 18.2586 4.93878 17.091 5.02405C16.9512 4.52174 16.6847 4.04727 16.2897 3.65225L15.4043 5.42309C15.3462 5.31725 15.2727 5.21764 15.183 5.12797C14.6735 4.61858 13.8477 4.61858 13.3383 5.12797C12.829 5.63736 12.8289 6.4632 13.3383 6.97259C13.428 7.06227 13.5277 7.13581 13.6335 7.19394L11.8627 8.07936C12.2578 8.47451 12.7326 8.74119 13.2352 8.88087C13.1496 10.0484 13.5524 11.2448 14.4452 12.1376L16.4036 9.61953C16.5509 9.47445 16.7455 9.39434 16.9525 9.39434C17.1616 9.39434 17.3581 9.47572 17.5059 9.62361C17.6537 9.77141 17.7351 9.96795 17.7351 10.177C17.7351 10.386 17.6537 10.5825 17.5059 10.7304L18.2438 11.4683C18.5886 11.1234 18.7786 10.6648 18.7786 10.177C18.7786 9.77792 18.6513 9.39851 18.4163 9.08483C18.7587 9.17628 19.0824 9.35544 19.3505 9.62361C20.1643 10.4373 20.1643 11.7613 19.3505 12.575L20.0884 13.3129C20.6797 12.7216 21.0053 11.9355 21.0053 11.0993C21.0052 10.263 20.6795 9.47694 20.0883 8.88566Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1997",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgPapuaNewGuinea;
